// Types
import { APP_BECAME_HIDDEN, APP_BECAME_VISIBLE } from './appVisibilityTypes';

export const appBecameVisible = () => ({ type: APP_BECAME_VISIBLE });
export const appBecameHidden = () => ({ type: APP_BECAME_HIDDEN });
